module.exports = __webpack_public_path__ + "assets/img/drawItem3-24f6dd19.png";